import { render, staticRenderFns } from "./chapterFieldEdit.vue?vue&type=template&id=49d5b0f8&scoped=true"
import script from "./chapterFieldEdit.vue?vue&type=script&lang=js"
export * from "./chapterFieldEdit.vue?vue&type=script&lang=js"
import style0 from "./chapterFieldEdit.vue?vue&type=style&index=0&id=49d5b0f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d5b0f8",
  null
  
)

export default component.exports